export default {
    schoolCalendarEarliestEndDate: {
        read: {
            endpoint: '/api/v3/school-calendar/earliest-end-date'
        }
    }
}
